//Add loader animation to blog filter buttons on click

let blogFilterButton = document.querySelectorAll('.blog_filter_list .button');
for (let i = 0; i < blogFilterButton.length; i++ ) {
    blogFilterButton[i].addEventListener("click", function() {
        if (!this.classList.contains("active")) {
        this.classList.add("loading")
        }
    })
}